import { Component } from '@angular/core';

@Component({
  selector: 'app-examenes-periodicos-hero',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './examenes-periodicos-hero.component.css'
})
export class ExamenesPeriodicosHeroComponent {

  name="Exámenes Ocupacionales Periódicos";
  description = "Exámenes con el fin de identificar posibles problemas de salud en los empleados, asociados con las tareas que desempeñan.";
  description2 = "";
  routeLogo = "assets/img/enterprise/menu/ocupacionalesPeriodicos.svg";
  routeImage = "assets/img/enterprise/hero/fotoExamenesOcupacionales.svg"

}
